import type { ReactNode } from 'react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetTitle,
} from '@/components/ModalSheet'
import { Form, FormRow } from '@/components/Form'
import { Button } from '@/components/Button'

export interface NotesDialogProps {
  showing: boolean
  onRequestClose?: () => unknown
  onSubmit: () => unknown
  isSubmitPending: boolean
  children?: ReactNode
}

export function NotesDialog({
  showing,
  onRequestClose,
  onSubmit,
  isSubmitPending,
  children,
}: NotesDialogProps) {
  return (
    <ModalSheet showing={showing} onRequestClose={onRequestClose}>
      <ModalSheetHeader bordered withCloseButton>
        <ModalSheetTitle>Notes</ModalSheetTitle>
      </ModalSheetHeader>
      <ModalSheetContent>
        <ModalSheetContentBlock expanded>
          <Form>
            <FormRow>{children}</FormRow>
          </Form>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Save"
            variant="primary"
            testId="provide-notes-submit-button"
            onPress={onSubmit}
            isPending={isSubmitPending}
            isDisabled={isSubmitPending}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
